import React, { useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { useToasts } from "react-toast-notifications";
import { useMutation } from "../../../GraphQL/helpers";
import { Row, Column } from "../../global/grid";
import Button from "../../global/button";
import Modal, { ModalBody, ModalFooter } from "../../global/modal";
import Alert from "../../global/alert";
import Form, { FormInput } from "../../global/forms";
import Validator from "../../../utilities/validators";
import UPDATE_PASSWORD from "../../../GraphQL/mutations/updatePasword";
import errorHandler from "../../../utilities/errorHandler";

const ChangePasswordModal = ({
    onClose,
    innerRef,
    ...attributes
}) => {
    const { t } = useTranslation(["components.profile.changePasswordModal", "utilities.validators"]);
    const validatorsLocale = t("utilities.validators:validators", { returnObjects: true });
    const validator = new Validator(validatorsLocale);
    const { addToast } = useToasts();
    const formHook = useForm();
    const { handleSubmit, formState, watch } = formHook;
    const { isSubmitting } = formState;
    const [updatePassword, { loading }] = useMutation(UPDATE_PASSWORD);
    const [modalError, setModalError] = useState(null);
    const password = watch("password");
    let modalRef = useRef(null);
    if (innerRef) {
        modalRef = innerRef;
    }

    const onCloseHandler = () => {
        setModalError(null);
        onClose && onClose();
    };

    const onSubmit = async (data) => {
        try {
            const { data: { editarCuenta } } = await updatePassword({
                variables: { password: data.password },
            });
            const { errores } = editarCuenta;

            if (errores) {
                setModalError({ title: t("errors.default.title"), message: errores[0].mensaje });
            } else {
                addToast((
                    <strong>{t("updateConfirm")}</strong>
                ), {
                    appearance: "success",
                    autoDismiss: false,
                });
                modalRef?.current && modalRef.current.close();
            }
        } catch (error) {
            errorHandler(error, () => {
                setModalError(t("errors.default", { returnObjects: true }));
            });
        }
    };

    return (
        <Modal
            {...attributes}
            title={t("title")}
            onClose={onCloseHandler}
            ref={modalRef}
        >
            <Form onSubmit={handleSubmit(onSubmit)}>
                <ModalBody>
                    {modalError && (
                        <Row>
                            <Column sm="12">
                                <Alert variant="danger" {...modalError}/>
                            </Column>
                        </Row>
                    )}

                    <Row>
                        <Column sm="12">
                            <FormInput
                              {...formHook}
                              validationRules={t("oldPassword.validator", { returnObjects: true })}
                              type="password"
                              name="oldPassword"
                              label={t("oldPassword.label")}
                              placeholder={t("oldPassword.placeholder")}
                            />
                        </Column>
                    </Row>
                    <Row>
                        <Column sm="12">
                            <FormInput
                              {...formHook}
                              validationRules={validator.password}
                              type="password"
                              name="password"
                              label={t("password.label")}
                              placeholder={t("password.placeholder")}
                            />
                        </Column>
                    </Row>
                    <Row>
                        <Column sm="12">
                            <FormInput
                              {...formHook}
                              validationRules={validator.confirmPassword(password)}
                              type="password"
                              name="confirmPassword"
                              label={t("confirmPassword.label")}
                              placeholder={t("confirmPassword.placeholder")}
                            />
                        </Column>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    {/*<Button type="button" block size="md" colors="light" onClick={() => toggleModal(false)}>{t("close")}</Button>*/}
                    <Button type="submit" block size="lg" colors="primaryWithBg" disabled={isSubmitting || loading} loading={isSubmitting}>{t("save")}</Button>
                </ModalFooter>
            </Form>

        </Modal>
    );
};

export default ChangePasswordModal;
